var $3d35878a3e01f32c$exports = {};
const $3d35878a3e01f32c$var$technologyParent = document.getElementById("all_technologies");
const $3d35878a3e01f32c$var$techSearchInput = document.getElementById("default_search");
const $3d35878a3e01f32c$var$techSuggestion = document.getElementById("suggestionsTech");
const $3d35878a3e01f32c$var$selectTechnologyParent = document.getElementById("select_technologies");
/* Js Technology toggle start */ const $3d35878a3e01f32c$var$toggleButton = document.getElementById("Tech_Toggle_Btn");
const $3d35878a3e01f32c$var$allTechnology = document.getElementById("all_technologies");
const $3d35878a3e01f32c$var$ScrollElement = document.getElementById("default_search");
const $3d35878a3e01f32c$var$ErorDiv = document.getElementById("Technology_Error");
const $3d35878a3e01f32c$var$Search_empty = document.getElementById("Empty_case");
let $3d35878a3e01f32c$var$addIcon = "https://cdn.quokkalabs.com/ql-images/add_technology.png";
let $3d35878a3e01f32c$var$removeIcon = "https://cdn.quokkalabs.com/ql-images/remove_technology.png";
$3d35878a3e01f32c$var$toggleButton.addEventListener("click", function() {
    let expandImg = document.getElementById("tech_expand_icon");
    if ($3d35878a3e01f32c$var$allTechnology.classList.contains("hidden")) {
        $3d35878a3e01f32c$var$allTechnology.classList.remove("hidden");
        $3d35878a3e01f32c$var$allTechnology.classList.add("flex");
        expandImg.setAttribute("src", "https://cdn.quokkalabs.com/ql-images/explore_close_icon.png");
        setTimeout(()=>{
            $3d35878a3e01f32c$var$allTechnology.style.opacity = 1;
            $3d35878a3e01f32c$var$allTechnology.style.height = "auto";
        }, 10);
    } else {
        $3d35878a3e01f32c$var$allTechnology.style.opacity = 0;
        $3d35878a3e01f32c$var$allTechnology.style.height = 0;
        expandImg.setAttribute("src", "https://cdn.quokkalabs.com/ql-images/explore_open_icon.png");
        setTimeout(()=>{
            $3d35878a3e01f32c$var$allTechnology.classList.add("hidden");
            $3d35878a3e01f32c$var$allTechnology.classList.remove("flex");
        }, 10);
    }
});
/* Js Technology toggle finish */ const $3d35878a3e01f32c$var$response_loader = document.querySelector("#response_loading_popup");
function $3d35878a3e01f32c$var$displayLoading() {
    if ($3d35878a3e01f32c$var$response_loader) {
        $3d35878a3e01f32c$var$response_loader.classList.remove("hidden");
        $3d35878a3e01f32c$var$response_loader.classList.add("block");
    }
    const submitBtn = document.getElementById("form-button");
    if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Submitting...";
    }
}
function $3d35878a3e01f32c$var$hideLoading() {
    if ($3d35878a3e01f32c$var$response_loader) {
        $3d35878a3e01f32c$var$response_loader.classList.add("hidden");
        $3d35878a3e01f32c$var$response_loader.classList.remove("block");
    }
    const submitBtn = document.getElementById("form-button");
    if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = "Submit";
    }
}
const $3d35878a3e01f32c$var$fetchedData = async function() {
    await fetch(`${"https://qkkalabs.com"}/blog/api/technologies`).then((response)=>response.json()).then(async (parsedData)=>{
        let techData = parsedData.data;
        const techlist = techData.map(({ id: id, name: name, image_url: image_url })=>{
            const TechnologyId = id;
            const TechnologyName = name;
            const ImgUrl = image_url;
            return `<div class="technology_btn inline-flex items-center border border-gray-500 bg-white bg-transparent Gilroy-medium cursor-pointer rounded p-3 mr-2 mb-2" data-name="${TechnologyName}" id="item_${TechnologyId}">
             <img src="${ImgUrl}" loading="lazy">
             <span class="ml-1 text-xs capitalize Gilroy-medium">${TechnologyName}</span>
         </div>`;
        }).join("");
        $3d35878a3e01f32c$var$technologyParent.innerHTML = techlist;
        techData.forEach((item)=>{
            const techEle = document.getElementById(`item_${item?.id}`);
            if (techEle) techEle.addEventListener("click", ()=>{
                const techListElements = document.getElementById(`list_${item?.id}`);
                if (techEle.classList.contains("select_tech")) {
                    const techListEle = document.getElementById(`tech_${item?.id}`);
                    techEle.classList.remove("select_tech");
                    techListElements?.classList.remove("select_tech");
                    if (techListEle && $3d35878a3e01f32c$var$selectTechnologyParent.contains(techListEle)) $3d35878a3e01f32c$var$selectTechnologyParent.removeChild(techListEle);
                    if (techListElements) {
                        const img = techListElements.getElementsByTagName("img")[0];
                        if (img) img.src = $3d35878a3e01f32c$var$addIcon;
                    }
                } else {
                    $3d35878a3e01f32c$var$technologyAdded(item);
                    techEle.classList.add("select_tech");
                    techListElements?.classList.add("select_tech");
                    if (techListElements) {
                        const img = techListElements.getElementsByTagName("img")[0];
                        if (img) img.src = $3d35878a3e01f32c$var$removeIcon;
                    }
                }
            });
        });
    }).catch((err)=>{
        console.error("Error while fetching Technologies - > ", err);
    });
};
$3d35878a3e01f32c$var$fetchedData();
/*This Code Through to APi Data Finish*/ function $3d35878a3e01f32c$var$technologyAdded(addTechData) {
    let icon_close_tag = document.createElement("img");
    icon_close_tag.setAttribute("src", "https://cdn.quokkalabs.com/ql-images/tech_cut_icon.png");
    icon_close_tag.setAttribute("class", "ml-1");
    icon_close_tag.addEventListener("load", ()=>{
        let selectTechCover = document.createElement("div");
        selectTechCover.classList.add("technology_btn", "inline-flex", "items-center", "border", "border-indigo-700", "cursor-pointer", "rounded", "p-3", "mr-2", "mb-2", "text-xs");
        selectTechCover.setAttribute("id", `tech_${addTechData.id}`);
        const addTechData2 = document.getElementById(`list_${addTechData?.id}`);
        let addedtech = document.createTextNode(addTechData.name);
        selectTechCover.appendChild(addedtech);
        selectTechCover.appendChild(icon_close_tag);
        selectTechCover.addEventListener("click", function() {
            const techItemEle = document.getElementById(`item_${addTechData?.id}`);
            const techlistEle = document.getElementById(`list_${addTechData?.id}`);
            techItemEle?.classList.remove("select_tech");
            techlistEle?.classList.remove("select_tech");
            if ($3d35878a3e01f32c$var$selectTechnologyParent.contains(selectTechCover)) $3d35878a3e01f32c$var$selectTechnologyParent.removeChild(selectTechCover);
            if (addTechData2) {
                const img = addTechData2.getElementsByTagName("img")[0];
                if (img) img.src = $3d35878a3e01f32c$var$addIcon;
            }
        });
        $3d35878a3e01f32c$var$selectTechnologyParent.appendChild(selectTechCover);
    });
}
function $3d35878a3e01f32c$var$myDebounce(callback, delay) {
    let timer;
    return function() {
        if (timer) clearTimeout(timer);
        timer = setTimeout(()=>{
            callback();
        }, delay);
    };
}
const $3d35878a3e01f32c$var$debounce = $3d35878a3e01f32c$var$myDebounce(()=>{
    if ($3d35878a3e01f32c$var$techSearchInput.value.trim()) {
        const childIds = [];
        if ($3d35878a3e01f32c$var$selectTechnologyParent) {
            const childElements = $3d35878a3e01f32c$var$selectTechnologyParent.children;
            for(let i = 0; i < childElements.length; i++){
                const childId = childElements[i].id;
                if (childId) childIds.push(childId);
            }
        }
        console.log({
            childIds: childIds
        });
        fetch(`${"https://qkkalabs.com"}/blog/api/technologies?search=${$3d35878a3e01f32c$var$techSearchInput.value.trim()}`).then((response)=>response.json()).then((parsedData)=>{
            $3d35878a3e01f32c$var$Search_empty.classList.remove("flex"), $3d35878a3e01f32c$var$Search_empty.classList.add("hidden"), $3d35878a3e01f32c$var$toggleButton.classList.remove("pt-4");
            const itemDivUl = document.createElement("ul");
            itemDivUl.classList.add("w-full", "bg-white", "mb-6");
            for(let i = 0; i < parsedData.data.length; i++){
                let itemDiv = document.createElement("li");
                const existEle = childIds.find((item)=>item === `tech_${parsedData.data[i]?.id}`);
                itemDiv.innerHTML = `
          <div class="flex items-center">
            <img src=${existEle ? $3d35878a3e01f32c$var$removeIcon : $3d35878a3e01f32c$var$addIcon}  loading="lazy"/>
            <span class="ml-1 text-xs capitalize Gilroy-medium">${parsedData.data[i]?.name}</span>
          </div>`;
                itemDiv.setAttribute("id", `list_${parsedData.data[i]?.id}`);
                itemDiv.classList.add("px-4", "py-3", "w-full", "block", "cursor-pointer", "border", "border-b-gray-500", "search_list_hover");
                if (existEle) itemDiv.classList.add("select_tech");
                itemDivUl.append(itemDiv);
            }
            $3d35878a3e01f32c$var$techSuggestion.innerHTML = "";
            $3d35878a3e01f32c$var$techSuggestion.appendChild(itemDivUl);
            for (const data of parsedData.data){
                const techId = data.id;
                const element = document.getElementById(`list_${techId}`);
                if (element) {
                    let changeIcon = element.querySelector("img");
                    element.addEventListener("click", ()=>{
                        if (element.classList.contains("select_tech")) {
                            element.classList.remove("select_tech");
                            const techEle = document.getElementById(`tech_${data?.id}`);
                            const techItemEle = document.getElementById(`item_${data?.id}`);
                            if (techEle && $3d35878a3e01f32c$var$selectTechnologyParent.contains(techEle)) $3d35878a3e01f32c$var$selectTechnologyParent.removeChild(techEle);
                            techItemEle?.classList.remove("select_tech");
                            if (changeIcon) changeIcon.src = $3d35878a3e01f32c$var$addIcon;
                        } else {
                            const techItemEle = document.getElementById(`item_${data?.id}`);
                            techItemEle?.classList.add("select_tech");
                            element.classList.add("select_tech");
                            if (changeIcon) changeIcon.src = $3d35878a3e01f32c$var$removeIcon;
                            $3d35878a3e01f32c$var$technologyAdded(data);
                        }
                    });
                }
            }
        }).catch((error)=>console.log({
                error: error
            }, $3d35878a3e01f32c$var$Search_empty.classList.remove("hidden"), $3d35878a3e01f32c$var$Search_empty.classList.add("flex"), $3d35878a3e01f32c$var$toggleButton.classList.add("pt-4")));
    } else {
        $3d35878a3e01f32c$var$techSuggestion.innerHTML = "";
        $3d35878a3e01f32c$var$Search_empty.classList.remove("flex"), $3d35878a3e01f32c$var$Search_empty.classList.add("hidden"), $3d35878a3e01f32c$var$toggleButton.classList.remove("pt-4");
    }
}, 500);
$3d35878a3e01f32c$var$techSearchInput.addEventListener("keyup", $3d35878a3e01f32c$var$debounce);
let $3d35878a3e01f32c$var$clientName = document.getElementById("Client_Name");
let $3d35878a3e01f32c$var$clientEmail = document.getElementById("Client_Email");
let $3d35878a3e01f32c$var$clientCompany = document.getElementById("Company_Name");
let $3d35878a3e01f32c$var$clientNumber = document.getElementById("Client_Mobile");
let $3d35878a3e01f32c$var$clientDetail = document.getElementById("Additional_Detail");
let $3d35878a3e01f32c$var$tags = document.getElementById("select_technologies");
const $3d35878a3e01f32c$var$confirmPopup = document.getElementById("response_loading_popup");
let $3d35878a3e01f32c$var$tagsArray = [];
function $3d35878a3e01f32c$var$isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}
async function $3d35878a3e01f32c$var$submitFormHire(event) {
    event.preventDefault();
    $3d35878a3e01f32c$var$tagsArray = [];
    let isFormValid = true;
    const nameErrorElement = document.getElementById("nameError");
    const nameErrorField = document.getElementById("Client_Name");
    if (!$3d35878a3e01f32c$var$clientName.value || $3d35878a3e01f32c$var$clientName.value.trim() === "") {
        nameErrorElement.classList.remove("hidden");
        nameErrorElement.classList.add("flex");
        nameErrorField.classList.add("border-red-500");
        isFormValid = false;
    } else {
        nameErrorElement.classList.remove("flex");
        nameErrorElement.classList.add("hidden");
        nameErrorField.classList.remove("border-red-500");
    }
    const emailErrorElement = document.getElementById("emailError");
    const emailErrorField = document.getElementById("Client_Email");
    if (!$3d35878a3e01f32c$var$clientEmail.value || $3d35878a3e01f32c$var$clientEmail.value.trim() === "") {
        emailErrorElement.classList.remove("hidden");
        emailErrorElement.classList.add("flex");
        emailErrorField.classList.add("border-red-500");
        isFormValid = false;
    } else if (!$3d35878a3e01f32c$var$isValidEmail($3d35878a3e01f32c$var$clientEmail.value.trim())) {
        alert("Invalid email address");
        emailErrorElement.classList.remove("hidden");
        emailErrorElement.classList.add("flex");
        emailErrorField.classList.add("border-red-500");
        isFormValid = false;
    } else {
        emailErrorElement.classList.remove("flex");
        emailErrorElement.classList.add("hidden");
        emailErrorField.classList.remove("border-red-500");
    }
    if (!isFormValid) return;
    const Mobile_Number = document.getElementById("Client_Mobile");
    const formD = new FormData();
    if (Mobile_Number.value.length < 9 && Mobile_Number.value.length > 0) {
        alert("Please add at least 9 digits phone number");
        return;
    } else if (Mobile_Number.value.length > 18) {
        alert("Please add maximum 18 digits phone number");
        return;
    } else formD.append("number", Mobile_Number.value);
    [
        ...$3d35878a3e01f32c$var$tags.children
    ].forEach((e)=>{
        const techName = e.innerText.replace(/\s+/g, " ").trim();
        if (techName) $3d35878a3e01f32c$var$tagsArray.push(techName);
    });
    $3d35878a3e01f32c$var$ErorDiv.classList.remove("block");
    $3d35878a3e01f32c$var$ErorDiv.classList.add("hidden");
    $3d35878a3e01f32c$var$technologyParent.classList.add("mt-3");
    formD.append("technology", JSON.stringify($3d35878a3e01f32c$var$tagsArray));
    formD.append("name", $3d35878a3e01f32c$var$clientName.value);
    formD.append("email", $3d35878a3e01f32c$var$clientEmail.value);
    formD.append("company_name", $3d35878a3e01f32c$var$clientCompany.value ? $3d35878a3e01f32c$var$clientCompany.value : "");
    formD.append("phone", $3d35878a3e01f32c$var$clientNumber.value ? $3d35878a3e01f32c$var$clientNumber.value : "");
    formD.append("description", $3d35878a3e01f32c$var$clientDetail.value ? $3d35878a3e01f32c$var$clientDetail.value : "");
    $3d35878a3e01f32c$var$displayLoading();
    fetch(`${"https://qkkalabs.com"}/blog/api/hire-talents`, {
        method: "POST",
        body: formD
    }).then((response)=>{
        if (!response.ok) throw new Error("API call failed");
        return response.json();
    }).then((data)=>{
        $3d35878a3e01f32c$var$hideLoading();
        if (data.status === true) {
            console.log({
                data: data
            });
            // Save data before clearing fields
            localStorage.setItem("contact_name", $3d35878a3e01f32c$var$clientName.value.trim());
            localStorage.setItem("contact_email", $3d35878a3e01f32c$var$clientEmail.value.trim());
            $3d35878a3e01f32c$var$clientName.value = "";
            $3d35878a3e01f32c$var$clientEmail.value = "";
            $3d35878a3e01f32c$var$clientCompany.value = "";
            $3d35878a3e01f32c$var$clientNumber.value = "";
            $3d35878a3e01f32c$var$clientDetail.value = "";
            $3d35878a3e01f32c$var$tagsArray = [];
            // Redirect keep same
            window.location.href = "/thankyou";
        } else {
            console.log("error");
            alert(data.message || "Failed to submit form. Please try again.");
        }
    }).catch((err)=>{
        $3d35878a3e01f32c$var$hideLoading();
        console.error("Error while submitting form - > ", err);
        alert("Failed to submit form. Please check your internet connection and try again.");
    });
}
function $3d35878a3e01f32c$var$closeConfirmPopup() {
    if ($3d35878a3e01f32c$var$confirmPopup) $3d35878a3e01f32c$var$confirmPopup.style.display = "none";
}
window.submitFormHire = $3d35878a3e01f32c$var$submitFormHire;
window.closeConfirmPopup = $3d35878a3e01f32c$var$closeConfirmPopup;
// THANK YOU PAGE DATA
document.addEventListener("DOMContentLoaded", ()=>{
    const userName = document.getElementById("userName");
    const userEmail = document.getElementById("userEmail");
    if (userName) userName.textContent = localStorage.getItem("contact_name") || "No Name Found";
    if (userEmail) userEmail.textContent = localStorage.getItem("contact_email") || "No Email Found";
});


//# sourceMappingURL=hire-talent.eea4593f.js.map
